import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { CategoryApplicationsStoreActions, DeviceStoreSelectors } from '@era/stores';
import { isNotUndefined } from '@rocksoft/shared';

@Injectable({ providedIn: 'root' })
export class DeviceConfiguredApplicationsResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DeviceStoreSelectors.selectCurrentDevice).pipe(
      filter(isNotUndefined),
      tap((device) => {
        if (device.brandUniqueId) {
          this.store.dispatch(
            CategoryApplicationsStoreActions.DeviceConfiguredApplicationsResolverActions.categoryApplicationsRequested({
              id: device.brandUniqueId,
              categoryType: 'Brand',
            })
          );
        }

        if (device.locationUniqueId) {
          this.store.dispatch(
            CategoryApplicationsStoreActions.DeviceConfiguredApplicationsResolverActions.categoryApplicationsRequested({
              id: device.locationUniqueId,
              categoryType: 'Location',
            })
          );
        }

        if (device.roomUniqueId) {
          this.store.dispatch(
            CategoryApplicationsStoreActions.DeviceConfiguredApplicationsResolverActions.categoryApplicationsRequested({
              id: device.roomUniqueId,
              categoryType: 'Room',
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
